import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { GenesysWidgetHeaderToolsComponent } from './genesys-widget-header-tools.component';
import { GenesysLaneButtonsModule } from 'shared/components/genesys-lane-buttons/genesys-lane-buttons.module';
import { SvgIconModule } from 'shared/components/svg-icon/svg-icon.module';
import { TooltipModule } from 'shared/components/tooltip/tooltip.module';

@NgModule({
  declarations: [
    GenesysWidgetHeaderToolsComponent
  ],
  imports: [
    CommonModule,
    GenesysLaneButtonsModule,
    SvgIconModule,
    TooltipModule,
    TranslateModule.forChild()
  ],
  exports: [
    GenesysWidgetHeaderToolsComponent
  ]
})
export class GenesysWidgetHeaderToolsModule { }
